<script setup>
import { ref, onMounted } from 'vue';
import DatePicker from 'vue-datepicker-next';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const emit = defineEmits(['close', 'chooseTime']);

const dialogRef = ref(null);
const snoozeTime = ref(null);
const lang = {
  days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  yearFormat: 'YYYY',
  monthFormat: 'MMMM',
};

const disabledDate = date => {
  // Disable all the previous dates
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  return date < yesterday;
};

const disabledTime = date => {
  // Allow only time after 1 hour
  const now = new Date();
  now.setHours(now.getHours() + 1);
  return date < now;
};

onMounted(() => {
  dialogRef.value?.open();
});
</script>

<template>
  <Dialog
    ref="dialogRef"
    :title="$t('CONVERSATION.CUSTOM_SNOOZE.TITLE')"
    :confirm-button-label="$t('CONVERSATION.CUSTOM_SNOOZE.APPLY')"
    :cancel-button-label="$t('CONVERSATION.CUSTOM_SNOOZE.CANCEL')"
    @confirm="emit('chooseTime', snoozeTime)"
    @close="emit('close')"
  >
    <DatePicker
      v-model:value="snoozeTime"
      type="datetime"
      inline
      input-class="mx-input"
      :lang="lang"
      :disabled-date="disabledDate"
      :disabled-time="disabledTime"
    />
  </Dialog>
</template>
